module.exports = __webpack_public_path__ + "static/media/discover2.8cb3e439.webp";